<nb-card>
  <nb-card-header>
    <h6 class="text-heading">
      {{ title }}
    </h6>
  </nb-card-header>
  <nb-card-body *ngIf="description">
    <p class="description">{{ description }}</p>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton outline status="info" (click)="cancel()">Từ Chối</button>
    <button nbButton hero status="primary" (click)="submit(true)">
      Đồng Ý
    </button>
  </nb-card-footer>
</nb-card>
